<ng-container *ngFor="let announcement of announcements">
  <div class="announcement" *ngIf="announcement.visible">
    <a *ngIf="announcement.link" class="link-announcement" [routerLink]="announcement.link">
      {{ announcement.message }}
    </a>
    <span *ngIf="!announcement.link">{{ announcement.message }}</span>
    <i class="material-icons" (click)="$event.preventDefault(); announcement.visible = false"
      >close</i
    >
  </div>
</ng-container>

<mat-toolbar role="heading" class="zeva-header">
  <div class="left-header">
    <!-- <div class="sidenav-trigger" (click)="toggleSidenav()">
      <mat-icon>{{ sidenavService.opened ? 'close' : 'menu' }}</mat-icon>
    </div> -->
    <div class="sidenav-logo-container">
      @switch (logo) {
        @case ('default') {
          <img
            src="/assets/zeva-logo-{{
              (themeService.currentTheme$ | async) === Theme.LIGHT ? 'dark-blue' : 'white'
            }}.svg"
            class="sidenav-logo"
          />
        }
        @case ('white') {
          <img src="/assets/zeva-logo-white.svg" class="sidenav-logo" />
        }
      }
    </div>

    <div class="telemetry-notice" *ngIf="showTelemetryPrereqs">
      <div style="display: flex; align-items: center">
        <mat-icon> warning_amber </mat-icon>
        <div class="telemetry-info">
          <p>{{ 'header.telemetryNotice' | transloco }}</p>
          <a (click)="telemetryPopup()">{{ 'header.view' | transloco }}</a>
        </div>
      </div>
    </div>
  </div>

  <div class="right-header">
    <ng-container *ngIf="quickAccessTemplate !== undefined">
      <div class="quick-access">
        <ng-container *ngTemplateOutlet="quickAccessTemplate"></ng-container>
      </div>

      <mat-divider [vertical]="true" />
    </ng-container>

    <!-- <button
      mat-flat-button
      color="primary"
      [routerLink]="'/admin/manage-subscription'"
      *ngIf="subscriptionService.isFreePlan$ | async"
      style="margin-right: 1rem"
    >
      Upgrade to Premium
    </button> -->

    @if (!!user && !!account) {
      <!-- ZEBOT -->
      <mat-icon
        svgIcon="zebot"
        color="primary"
        style="margin: 0 1rem; cursor: pointer"
        *ngIf="user.is_superuser || account.data_type === 'FM'"
        trackElement="Alan"
        [trackEvents]="['click', 'mouseenter', 'mouseleave']"
        (click)="zebotCont.toggle(); zebot.startChat()"
      ></mat-icon>

      <!-- Account Management Menu -->
      <div
        class="header-account"
        cdkOverlayOrigin
        [popoverTriggerFor]="menuOverlay"
      >
        <div class="full">
          <span class="name">
            {{ user.first_name }}
            <ng-container *ngIf="user.last_name"> {{ user.last_name }}</ng-container>
          </span>
          <!-- Show account name if FM & SI account is selected -->
          <div
            class="account th-color-secondary-text"
            *ngIf="account && account.data_type !== AccountType.IN"
          >
            <span class="subscript">{{ 'header.account' | transloco }}</span>
            {{ account.company_name }}
          </div>
          <!-- Show user Email if IN account or no account is selected -->
          <div
            class="account th-color-secondary-text"
            *ngIf="!account || account.data_type === AccountType.IN"
          >
            <span class="subscript">{{ user.email }}</span>
          </div>
        </div>
        <span class="short">
          <mat-icon>person_outline</mat-icon>
        </span>
      </div>

      <shared-popover #menuOverlay backdropClass="cdk-overlay-dark-backdrop">
        <div class="zeva-card elevated account-menu">
          @if (accounts.length > 1) {
            <button
              mat-flat-button
              [trackElement]="account ? 'Change Account' : 'Select Account'"
              [trackEvents]="['click', 'mouseenter', 'mouseleave']"
              (click)="onChangeAccount()"
            >
              <mat-icon>transit_enterexit</mat-icon>
              <span>{{
                account ? ('header.changeAccount' | transloco) : ('header.selectAccount' | transloco)
              }}</span>
            </button>
          }
          <button
            mat-flat-button
            routerLink="/admin/profile"
            trackElement="Preferences"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
          >
            <mat-icon>tune</mat-icon>
            <span>{{ 'header.preferences' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-flat-button
            trackElement="Help"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="supportClick()"
          >
            <mat-icon>contact_support</mat-icon>
            <span>{{ 'header.help' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-flat-button
            trackElement="Feedback"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="feedbackClick()"
          >
            <mat-icon>feedback</mat-icon>
            <span>{{ 'header.feedback' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-flat-button
            trackElement="Sign Out"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="onSignOut()"
          >
            <mat-icon>logout</mat-icon>
            <span>{{ 'header.signOut' | transloco }}</span>
          </button>
        </div>
      </shared-popover>
    }
  </div>
</mat-toolbar>
